//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Card from './_card'
export default {
    props: {
        price_compares: Object
    },
    components: {
        Card
    },
    methods: {
        goMore(value) {
            const { link } = value
            if (link) {
                wx.navigateTo({
                    url: link
                })
            }
        }
    }
}
